module.exports = __webpack_public_path__ + "static/media/slider-business-slide-02-image-01.80b2a6e2.png";